export const LRS_PAGE = {
    BENCHMARK_PAGE: 'Benchmark Page',
    PROGRESS_PAGE: 'Progress Page',
    INSTRUCTIONS_PAGE: 'Instructions Page',
    HOME_CONNECT_PAGE: 'Home Connect Page',
    DUAL_LANGUAGE_PAGE: 'Dual Language Page',
    STUDENT_SUMMARY_BENCHMARK_HISTORY_PAGE: 'Benchmark History Page of Student Summary',
    STUDENT_SUMMARY_TEXT_READING_HISTORY_PAGE: 'Text Reading History Page of Student Summary',
    STUDENT_SUMMARY_PROGRESS_PAGE: 'Progress Page of Student Summary',
};

export const LRS_NAVIGATION_TAB = {
    INSTRUCTION: 'instructionTab',
};

export const LRS_VERBS = {
    ACCESSED: 'accessed',
    LAUNCHED: 'launched',
    SELECTED: 'selected',
    DOWNLOADED: 'downloaded',
    VIEWED: 'viewed',
    PRESSED: 'pressed',
    DEFINED: 'defined',
};
export const HOME_CONNECT_DOWNLOAD = 'Home Connect Download';

export const LRS_CONTEXT_EXTENSIONS = {
    TIME_OF_YEAR: 'time-of-year',
    RECOMMENDED_ACTIVITY: 'recommended-activity',
    FROM_ROUTE_NAME: 'from-route-name',
    NAME_SORT: 'name-sort',
    HELP_ITEM: 'help-item',
    PRINT_ITEM: 'print-item',
    GRADE: 'grade',
    YEAR: 'year',
    PROBE_DETAILS: 'probe-details',
    PROBE_LOCATION: 'probe-location',
    ZOOM_DETAILS: 'zoom-details',
    BUTTON_STATUS: 'button-status',
    BUTTON_TEXT: 'button-text',
    RECOMMENDATION: 'recommendation',
    RECOMMENDATION_TIME: 'recommendation-time',
    PAST_RECOMMENDATION_TIME: 'past-recommendation-time',
    DOWNLOAD_LOCATION: 'download-location',
    PREVIOUS_SEE_ACTIVITIES: 'previous-see-activities',
    PAGINATION_SELECTED: 'pagination-selected',
    PARENT_SKILL: 'parent-skill',
    PARENT_GRADE: 'parent-grade',
    ETERNAL_STUDENT_ID: 'eternal-student-id',
    TIME_FRAME: 'time-frame',
    LANGUAGE_CONSIDERATIONS: 'language-considerations',
    DISTRICT_ID: 'district-id',
    SCHOOL_ID: 'school-id',
    CLASS_ID: 'class-id',
    GROUP_ID: 'group-id',
};

export const LRS_XAPI_LOCATION_OBJECT_IDS = {
    [LRS_PAGE.DUAL_LANGUAGE_PAGE]: 'https://api.amplify.com/xapi/objects/dual-language-dashboard',
    [LRS_PAGE.BENCHMARK_PAGE]: 'https://api.amplify.com/xapi/objects/benchmark-dashboard',
    [LRS_PAGE.STUDENT_SUMMARY_BENCHMARK_HISTORY_PAGE]:
        'https://api.amplify.com/xapi/objects/benchmark-dashboard-benchmark-history',
    [LRS_PAGE.STUDENT_SUMMARY_TEXT_READING_HISTORY_PAGE]:
        'https://api.amplify.com/xapi/objects/benchmark-dashboard-text-reading-history',
    [LRS_PAGE.STUDENT_SUMMARY_PROGRESS_PAGE]:
        'https://api.amplify.com/xapi/objects/benchmark-dashboard-progress',
    [LRS_PAGE.PROGRESS_PAGE]: 'https://api.amplify.com/xapi/objects/progress-dashboard',
    [LRS_PAGE.INSTRUCTIONS_PAGE]: 'https://api.amplify.com/xapi/objects/instruction-dashboard',
    [LRS_PAGE.HOME_CONNECT_PAGE]: 'https://api.amplify.com/xapi/objects/home-connect-dashboard',
};

export const LRS_XAPI_ONCLICK_OBJECT_IDS = {
    EVENT_HELP_ITEM: 'https://api.amplify.com/xapi/objects/header-events-help-icon',
    EVENT_PRINT_ITEM: 'https://api.amplify.com/xapi/objects/header-events-print-item',
    EVENT_DOWNLOAD_PDF_LANGUAGE_CONSIDERATION:
        'https://api.amplify.com/xapi/objects/instruction-dashboard-groups-language-consideration',
};

export const LRS_EVENTS_XAPI_IDS = {
    SWITCH_PERIOD: 'time-of-year',
    SELECT_INDIVIDUAL_STUDENT: 'individual-student',
    DOWNLOAD_STUDENT_ACTIVITY: 'recommended-activity',
    SORT_STUDENTS_BY_NAME: 'name-sort',
    SELECT_STUDENT: 'benchmark-history',
    PROBE_DETAIL_VISITING_EVENT: 'probe',
    SWITCH_INSTRUCTION_DATE: 'past-recommendation',
    VIEW_LATEST_UPDATE_RECOMMENDATION: 'update-recommendation',
    HELP_DETAILS: 'pattern-help',
    SEE_ACTIVITIES: 'see-activities',
    OBSERVATION_SELECT: 'observed-patterns',
    DOWNLOAD_ALL_ACTIVITIES: 'all-activities',
    SELECT_PAGE: 'observed-patterns',
    SPECIFIC_ACTIVITY: 'specific-activity',
    SELECT_SKILL: 'skills-resources',
    DOWNLOAD_ACTIVITY: 'specific-activity',
    SWITCH_INSTRUCTION_TAB: 'instruction',
};

export const LRS_RESULT_EXTENSIONS = {
    INSTRUCTIONAL_ACTIVITY_ID: 'instructional-activity-id',
    SEE_ACTIVITIES: 'see-activities',
    PATTERN_OBSERVED: 'pattern-observed',
    PATTERN_CATEGORY: 'pattern-category',
    PATTERN_ASSESSMENT: 'pattern-assessment',
    PATTERN_ENABLED: 'pattern-enabled',
    PAGINATION_SHOWN: 'pagination-shown',
    STUDENT_ENGLISH_ID: 'student-english-id',
    STUDENT_SPANISH_ID: 'student-spanish-id',
    RECOMMENDATION_TIME: 'recommendation-time',
    SKILL: 'skill',
    PREVIOUS_GOAL_RANGE: 'previous-goal-range',
    PREVIOUS_GOAL_LEVEL: 'previous-goal-level',
    PREVIOUS_GOAL_SCORE: 'previous-goal-score',
    GOAL_SCORE: 'goal-score',
    NAME_SHOWN: 'name-shown',
    NAME_LIST: 'name-list',
    NAME_SELECTED: 'name-selected',
};

export const STUDENT_SUMMARY_TABS = [
    LRS_PAGE.STUDENT_SUMMARY_BENCHMARK_HISTORY_PAGE,
    LRS_PAGE.STUDENT_SUMMARY_TEXT_READING_HISTORY_PAGE,
    LRS_PAGE.STUDENT_SUMMARY_PROGRESS_PAGE,
];

export const HEADER_DROPDOWN_TYPES = {
    DISTRICT: 'district',
    SCHOOL: 'school',
    CLASS: 'class',
};

export const LRS_TAB_NAME = {
    PROGRESS: 'progress',
    TEXT_READING_HISTORY: 'text-reading-history',
};
